import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from '../store';

export interface WishlistItem {
    id: string | number;
    name: string;
    price: number;
    image: string;
    category: string;
}

interface WishlistState {
    items: WishlistItem[];
}

const initialState: WishlistState = {
    items: JSON.parse(localStorage.getItem('wishlist') || '[]'),
};

const wishlistSlice = createSlice({
    name: 'wishlist',
    initialState,
    reducers: {
        addToWishlist: (state, action: PayloadAction<WishlistItem>) => {
            const exists = state.items.find(item => item.id.toString() === action.payload.id.toString());
            if (!exists) {
                state.items.push(action.payload);
                localStorage.setItem('wishlist', JSON.stringify(state.items));
            }
        },
        removeFromWishlist: (state, action: PayloadAction<string | number>) => {
            state.items = state.items.filter(item => item.id.toString() !== action.payload.toString());
            localStorage.setItem('wishlist', JSON.stringify(state.items));
        },
        clearWishlist: (state) => {
            state.items = [];
            localStorage.removeItem('wishlist');
        },
    },
});

export const { addToWishlist, removeFromWishlist, clearWishlist } = wishlistSlice.actions;

// Selectors
export const selectWishlistItems = (state: IRootState) => state.wishlist.items;
export const selectWishlistCount = (state: IRootState) => state.wishlist.items.length;
export const selectIsInWishlist = (state: IRootState, productId: string | number) =>
    state.wishlist.items.some(item => item.id.toString() === productId.toString());

export default wishlistSlice.reducer;
